// AUTHOR : AGenecque
// USING : possibility to select which site can access to restricted pdp
// DATA : Site Id in array exemple : ["-1", "-2"];
// Only used in Normandie
export const SITE_USING_RESTRICTED_PDP = ['2', '4', '8']
